import React, { useState, useEffect } from 'react';
import { FaFlag, FaGlobe } from 'react-icons/fa';
import useUserSettings from '../../../shared/hooks/useUserSettings';

// Define chord modes as constants
const CHORD_MODES = {
  NONE: 'none',
  POLISH: 'polish',
  INTERNATIONAL: 'international'
};

export default () => {
  const { settings, updateSetting, isLoaded } = useUserSettings();
  const [chordMode, setChordMode] = useState(CHORD_MODES.NONE);

  // Load chord mode from settings
  useEffect(() => {
    if (isLoaded) {
      const savedMode = settings.chordMode || CHORD_MODES.NONE;
      setChordMode(savedMode);
    }
  }, [isLoaded, settings]);

  // Toggle chord mode: None -> Polish -> International -> None
  const toggleChordMode = () => {
    let newMode;
    
    switch (chordMode) {
      case CHORD_MODES.NONE:
        newMode = CHORD_MODES.POLISH;
        break;
      case CHORD_MODES.POLISH:
        newMode = CHORD_MODES.INTERNATIONAL;
        break;
      case CHORD_MODES.INTERNATIONAL:
      default:
        newMode = CHORD_MODES.NONE;
        break;
    }
    
    updateSetting('chordMode', newMode);
    setChordMode(newMode);
  };

  // Get the appropriate icon based on current mode
  const getChordModeIcon = () => {
    switch (chordMode) {
      case CHORD_MODES.POLISH:
        return (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
          }}>
            {/* Polish flag colors */}
            <div style={{ 
              width: '18px', 
              height: '12px', 
              background: 'white',
              borderRadius: '2px',
              overflow: 'hidden',
              position: 'relative'
            }}>
              <div style={{ 
                width: '100%', 
                height: '50%', 
                background: 'white'
              }}></div>
              <div style={{ 
                width: '100%', 
                height: '50%', 
                background: 'red',
                position: 'absolute',
                bottom: '0'
              }}></div>
            </div>
          </div>
        );
      case CHORD_MODES.INTERNATIONAL:
        return <FaGlobe style={{ 
          color: 'var(--active-item-text-color)'
        }} />;
      case CHORD_MODES.NONE:
      default:
        return <FaFlag style={{ 
          color: 'var(--menu-icon-inactive-color)'
        }} />;
    }
  };

  return (
    <div 
      onClick={toggleChordMode}
      style={{
        cursor: 'pointer',
        borderRadius: '30%',
        padding: '5px',
        // backgroundColor: chordMode !== CHORD_MODES.NONE ? 
        //   'var(--active-item-bg-color)' : 
        //   'transparent',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      role="button" tabIndex={0}
      aria-label={chordMode === CHORD_MODES.NONE ? "Wyświetlaj akordy w notacji polskiej" : 
             chordMode === CHORD_MODES.POLISH ? "Wyświetlaj akordy w notacji międzynarodowej" : 
             "Nie wyświetlaj akordów"}
      title={chordMode === CHORD_MODES.NONE ? "Wyświetlaj akordy w notacji polskiej" : 
             chordMode === CHORD_MODES.POLISH ? "Wyświetlaj akordy w notacji międzynarodowej" : 
             "Nie wyświetlaj akordów"}
    >
      {getChordModeIcon()}
    </div>
  );
};